<template>
  <div>
    <search-group @search="findData" @clear="clearValue">
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Input type="text" placeholder="搜索：商户名、商户号" v-model="searchData.merchantNoOrName" @keyup.enter.native="findData"></Input>
        </Col>
      </Row>
    </search-group>
    <Row class="mb16">
        <Button type="primary" v-p="{api:'merchant/save'}" @click="addN++">添加</Button>
    </Row>
    <table-list
      :columns="columns"
      :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"></table-list>
    <add :n="addN" @findData="initPageList"></add>
    <modify :n="modifyN" :fid="fid" @findData="initPageList"></modify>
  </div>
</template>

<script>
import SearchGroup from '@/components/SearchGroup'
import TableList from "@/components/TableList/index";
import Add from './components/Add'
import Modify from './components/Modify'
import { getList, del } from '@/api/MerchantMng'
import { formatDateTime } from "@/utils/format";

export default {
  name:'lifangtong',
  components:{
    SearchGroup,
    Add,
    Modify,
    TableList
  },
  data(){
    return{
      addN:0,
      modifyN:0,
      searchData:{},
      loading:false,
      current:1,
      fid:'',
      data:[{
        name:'1'
      }],
      columns:[
        {
          type:'index',
          width:60,
          align:'center'
        },
        {
          title:' '
        },
        {
          title: "商户名",
          key: "acMerchantName",
          align: "center",
          width:160,
        },
        {
          title:' '
        },
        {
          title: "商户号",
          key: "acMerchantNo",
          align: "center",
          width:200,
        },
        {
          title:' '
        },
        {
          title: "添加人",
          key: "createBy",
          align: "center",
          width:100,
        },
        {
          title:' '
        },
        {
          title: "创建时间",
          key: "createTime",
          align: "center",
          width:150,
          render:(h,params)=>{
						return h('span',{},formatDateTime(params.row['createTime']))
					}
        },
        {
          title:' '
        },
        {
          title: "操作",
          width:150,
          key: "action",
          align: "center",
          fixed:'right',
          render:(h,params)=>{
            return h(
              'div',{},[
                h('Button',{
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'merchant/update'
                      }
                    }
                  ],
                  style:{
                    marginRight: "5px"
                  },
                  on:{
                    click:()=>{
                      this.fid = params.row['fid']
                      this.modifyN++
                    }
                  }
                },'修改'),
                h('Button',{
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'merchant/delete'
                      }
                    }
                  ],
                  on:{
                    click:()=>{
                      // 删除
                      this.$Modal.confirm({
                      title:'收款账户删除',
                      content:'<p>确认删除本条记录？</p>',
                      onOk:()=>{
                        del({merchantFid:params.row.fid}).then(res=>{
                          this.$Message.success('删除成功')
                          // this.current=1
                          // this.page=1
                          this.findData()
                        }).catch(error=>{})
                      }
                    })
                    }
                  }
                },'删除'),
              ]
            )
          }
        },
      ],
      total:0,
      limit:10,
      page: 1,
    }
  },
  created(){
    this.findData()
  },
  methods:{
    findData(){
      this.page = 1
      this.current = 1
      this.initPageList()
    },
    initPageList(){
      getList({
				page:this.page,
        limit:this.limit,
        ...this.searchData
      }).then(res => {
        console.log(res)
        this.data = res.data.rows;
        this.total=res.data.total
      }).catch(error=>{})
    },
    changePage(n){
      this.current = n;
      this.searchData.page=n;
      this.initPageList()
    },
    clearValue(){
      this.searchData = {}
    }
  }

}
</script>

<style>

</style>